module.exports = __webpack_public_path__ + "media/images/flags/PM-aae6338ae9bab3b2aa64ab03f6b8e903.svg";